
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		value: String
	},
	computed: {
		title():TranslateResult{
			return this.$ct("common.image");
		}
	},
	methods: {
		onModalInput(value:boolean){
			if (value) return;
			this.$emit("input", "");
		}
	}
});
